export default {
    dashboard: {
        title: 'Trendmanager Frontend',
        tooltip: 'Dashboard'
    },
    companyTrends: {
        title: 'Company-Trends',
        tooltip: 'Company-Trends'
    },
    trendoneUniverse: {
        title: 'TRENDONE-Trenduniverse',
        tooltip: 'TRENDONE-Trenduniverse'
    },
    user: {
        title: 'Company User Management',
        tooltip: 'Company User Management'
    },
    logout: {
        title: 'Log out',
        tooltip: 'Log out'
    }
}
